// extracted by mini-css-extract-plugin
export default {"layout":"LoadingScreen_layout__j1Hz3","content":"LoadingScreen_content__tf9g1","lottie-wrapper":"LoadingScreen_lottie-wrapper__BoxWM"};